import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import RefreshTable from '../RefreshTable';
import FinesTotalCapsule from '../FinesTotalCapsule';

import BorrowingUtilityBar from '../../shared/BorrowingUtilityBar';

import './FinesUtilityBar.scss';

const renderTitle = (summary, handleRefresh, home, onlineFinesPayment) => {
  const showAccruedCapsule = !!summary.get('totalAccrued');
  const showCreditsCapsule = !!summary.get('totalCredits');

  return (
    <div className="utility-context-info">
      <FinesTotalCapsule status="due" amount={summary.get('totalFines', 0)} />
      {showAccruedCapsule && <FinesTotalCapsule status="accruing" amount={summary.get('totalAccrued')} />}
      {showCreditsCapsule && <FinesTotalCapsule status="credit" amount={summary.get('totalCredits')} />}
      {onlineFinesPayment &&
        <RefreshTable handleRefresh={handleRefresh} home={home} />
      }
    </div>
  );
};

export default function FinesUtilityBar({ isFetching, sortOptions, summary, handleRefresh, home, pagination, onlineFinesPayment }) {
  const totalFines = summary.get('totalFines', 0);
  return (
    <BorrowingUtilityBar
      className="cp-fines-utility-bar"
      isFetching={isFetching}
      pagination={pagination}
      title={renderTitle(summary, handleRefresh, home, onlineFinesPayment)}
      sortOptions={totalFines > 0 && sortOptions} />
  );
}

FinesUtilityBar.propTypes = {
  isFetching: PropTypes.bool,
  sortOptions: ImmutablePropTypes.list,
  handleRefresh: PropTypes.func,
  home: PropTypes.string,
  onlineFinesPayment: PropTypes.bool,
  summary: ImmutablePropTypes.map,
  pagination: ImmutablePropTypes.map
};



// WEBPACK FOOTER //
// ./app/components/borrowing/fines/FinesUtilityBar/FinesUtilityBar.jsx